/**
* Results Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Results Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'results-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let sliderCounter = 0;
      let sliderElements = '';

      if ( $( '.results-slider' ).length ) {
        sliderCounter++;
        if ( sliderElements === '' ) {
          sliderElements += '.results-slider';
        } else {
          sliderElements += ', .results-slider';
        }
      }

      $( '.results-slider__slider' ).slick( {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        waitForAnimate: false,
        centerPadding: '120px',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerPadding: '0',
            },
          },
        ],
      } );

      const slides = $( '.results-slider__result:not(.slick-cloned)' ).length;

      $( '.line-wrapper .line' ).width( ( ( 1 / slides ) * 100 ) + '%' );

      $( '.results-slider .results-slider__slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
        $( '.results-slider .line-wrapper .line' ).css( 'left', ( ( nextSlide / slides ) * 100 ) + '%' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'results-slider', COMPONENT );
} )( app );
